import { useEffect, useState } from "react";
import type { AdminDashboardRuntimeConfig } from "../../app/composition/admin-dashboard-runtime-config";

export const ADMIN_AUTO_REFRESH_INTERVAL_MS = 60_000;

type AdminAutoRefreshConfig = Pick<AdminDashboardRuntimeConfig, "authMode">;

export function resolveAdminLiveTimeRangeRefreshSeed(
  searchParams: URLSearchParams,
  refreshTick: number,
): number {
  const explicitTo = resolveExplicitAdminTimeRangeUpperBound(searchParams);
  return explicitTo ? 0 : refreshTick;
}

export function resolveExplicitAdminTimeRangeUpperBound(
  searchParams: URLSearchParams,
): string | undefined {
  const explicitTo = searchParams.get("to")?.trim();
  return explicitTo && explicitTo.length > 0 ? explicitTo : undefined;
}

export function clearExplicitAdminTimeRangeSearchParams(
  searchParams: URLSearchParams,
): URLSearchParams {
  const nextSearchParams = new URLSearchParams(searchParams);
  nextSearchParams.delete("from");
  nextSearchParams.delete("to");
  nextSearchParams.delete("cursor");
  return nextSearchParams;
}

export function clearHiddenAdminListCursorSearchParams(
  searchParams: URLSearchParams,
): URLSearchParams {
  const nextSearchParams = new URLSearchParams(searchParams);
  nextSearchParams.delete("cursor");
  return nextSearchParams;
}

export function resolveAdminAutoRefreshIntervalMs(
  runtimeConfig: AdminAutoRefreshConfig,
): number | undefined {
  return runtimeConfig.authMode === "admin-auth" ? ADMIN_AUTO_REFRESH_INTERVAL_MS : undefined;
}

export function useAdminAutoRefreshTick(
  runtimeConfig: AdminAutoRefreshConfig,
): number {
  const [tick, setTick] = useState(0);
  const intervalMs = resolveAdminAutoRefreshIntervalMs(runtimeConfig);

  useEffect(() => {
    if (intervalMs === undefined) {
      return undefined;
    }

    const timer = window.setInterval(() => {
      setTick((current) => current + 1);
    }, intervalMs);

    return () => {
      window.clearInterval(timer);
    };
  }, [intervalMs]);

  return tick;
}
